// id
const ID_TAB_BRANCH = "table-branch-tab";
const ID_TAB_CASHDESK = "table-cashdesk-tab";
const ID_TABLE_BRANCH = "table-branch";
const ID_TABLE_CASHDESK = "table-cashdesk";

// class
const CLASS_ACTIVE = "is-active";
const CLASS_FLEX = "flex";
const CLASS_HIDDEN = "hidden";

const branchDetailPageTabs = () => {
  // tab 'Branch'
  const tabBranch = document.getElementById(ID_TAB_BRANCH);

  const addActiveClassBranch = () => {
    tabBranch.classList.add(CLASS_ACTIVE);
  };
  const removeActiveClassBranch = () => {
    tabBranch.classList.remove(CLASS_ACTIVE);
  };

  // tab 'CashDesk'
  const tabCashDesk = document.getElementById(ID_TAB_CASHDESK);

  const addActiveClassCashDesk = () => {
    tabCashDesk.classList.add(CLASS_ACTIVE);
  };
  const removeActiveClassCashDesk = () => {
    tabCashDesk.classList.remove(CLASS_ACTIVE);
  };

  // table 'Branch'
  const tableBranch = document.getElementById(ID_TABLE_BRANCH);
  tableBranch.classList.add(CLASS_FLEX); // show by default

  const showTableBranch = () => {
    tableBranch.classList.remove(CLASS_HIDDEN);
    tableBranch.classList.add(CLASS_FLEX);
  };
  const hideTableBranch = () => {
    tableBranch.classList.remove(CLASS_FLEX);
    tableBranch.classList.add(CLASS_HIDDEN);
  };

  // table 'Cashdesk'
  const tableCashDesk = document.getElementById(ID_TABLE_CASHDESK);
  tableCashDesk.classList.add(CLASS_HIDDEN); // hide by default

  const showTableCashDesk = () => {
    tableCashDesk.classList.remove(CLASS_HIDDEN);
    tableCashDesk.classList.add(CLASS_FLEX);
  };
  const hideTableCashDesk = () => {
    tableCashDesk.classList.remove(CLASS_FLEX);
    tableCashDesk.classList.add(CLASS_HIDDEN);
  };

  // handle click - tab 'Branch'
  tabBranch.addEventListener("click", () => {
    addActiveClassBranch();
    showTableBranch();

    if (tabCashDesk) {
      removeActiveClassCashDesk();
      hideTableCashDesk();
    }
  });

  // handle click - tab 'CashDesk'
  tabCashDesk.addEventListener("click", () => {
    addActiveClassCashDesk();
    showTableCashDesk();

    removeActiveClassBranch();
    hideTableBranch();
  });
};

export default branchDetailPageTabs;
